import { createApp } from 'vue'
import App from './App.vue'
import '@/index.css';

window.app = createApp(App).mount('#app')
